import { GetServerSideProps } from 'next';
import { useEffect } from 'react';

import BackgroundBlobs from '../components/_molecules/BackgroundBlobs/BackgroundBlobs';
import useSignOut from '../hooks/useSignOut';

const Logout = () => {
  const { b2cSignout } = useSignOut();

  useEffect(() => {
    b2cSignout();
  }, [b2cSignout]);
  return (
    <>
      <BackgroundBlobs />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async context => {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=300, stale-while-revalidate=3600',
  );

  return {
    props: {},
  };
};

export default Logout;
